import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { Grid, Theme, Button, Modal, Divider } from '@material-ui/core';
import { useRecoilState } from 'recoil';
import { btnColor } from '../GlobalState';
import { makeStyles, createStyles } from '@material-ui/core/styles';

import { mapProps } from './ConstructSiteMap';

interface mapModalProps extends mapProps {
  modalOpen: boolean;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
}

const MapMarkerModal: React.FC<mapModalProps> = ({
  latitude,
  longitude,
  setLatitude,
  setLongitude,
  convertToLatLng,
  isMarkerChecked,
  setIsMarkerChecked,
  modalOpen,
  setModalOpen
}) => {
  const [buttonColor] = useRecoilState(btnColor);
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      paper: {
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.spacing(2),
        boxShadow: theme.shadows[5],
        width: '50%',
        maxHeight: '120vh',
        overflowY: 'scroll'
      },
      header: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2, 4),
        borderRadius: theme.spacing(2, 2, 0, 0)
      },
      map: {
        paddingTop: 0,
        paddingLeft: 10,
        paddingRight: 10
      }
    })
  );
  const classes = useStyles();

  const mapStyles = {
    width: '100%',
    height: '300px'
  };

  //マーカーの緯度経度
  const [markerPosition, setMarkerPosition] =
    useState<google.maps.LatLngLiteral>();
  //地図の中心
  const [center, setCenter] = useState<google.maps.LatLngLiteral>({
    lat: latitude,
    lng: longitude
  });

  //親コンポーネントから緯度経度の変更があったときマーカー座標を更新する
  useEffect(() => {
    setMarkerPosition({
      lat: latitude,
      lng: longitude
    });
    setCenter({
      lat: latitude,
      lng: longitude
    });
  }, [latitude, longitude, modalOpen]);

  //マップをクリックした際、マーカー座標を更新
  const onClickMap = (e: google.maps.MapMouseEvent) => {
    setMarkerPosition({
      lat: e.latLng?.lat()!,
      lng: e.latLng?.lng()!
    });
  };

  //マーカーをドラッグした際、マーカー座標を更新
  const onDragMarker = (e: google.maps.MapMouseEvent) => {
    setMarkerPosition({
      lat: e.latLng?.lat()!,
      lng: e.latLng?.lng()!
    });
  };
  //ここでOKボタンを押したときに、マーカー座標を親コンポーネントに反映
  const onSaveMarker = () => {
    setLatitude(markerPosition?.lat!);
    setLongitude(markerPosition?.lng!);
  };

  return (
    <Modal
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      className={classes.modal}
    >
      <Grid className={classes.paper}>
        <Grid className={classes.header}>ピンの位置を確認</Grid>
        <Divider style={{ backgroundColor: '#CCCCCC', marginBottom: 10 }} />
        <Grid container justify={'center'}>
          <Grid item xs={12} className={classes.map}>
            <LoadScript
              googleMapsApiKey={`${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`}
            >
              <GoogleMap
                mapContainerStyle={mapStyles}
                center={center}
                zoom={17}
                onClick={onClickMap}
              >
                {markerPosition ? (
                  <Marker
                    position={markerPosition}
                    draggable={true}
                    //onDrag={onDragMarker}
                    onDragEnd={onDragMarker}
                  ></Marker>
                ) : (
                  <></>
                )}
              </GoogleMap>
            </LoadScript>
            ※ピンをドラッグするか、地図をクリックして調節してください
            <div>
              <Button
                style={{
                  color: '#fff',
                  backgroundColor: buttonColor,
                  textAlign: 'center',
                  marginLeft: 10,
                  marginTop: 20,
                  marginBottom: 10
                }}
                onClick={() => {
                  convertToLatLng(true);
                }}
              >
                住所を地図に反映
              </Button>
            </div>
          </Grid>
        </Grid>
        <Divider style={{ backgroundColor: '#CCCCCC' }} />
        <Grid style={{ textAlign: 'right' }}>
          <Button
            style={{
              textAlign: 'center',
              marginRight: 10,
              marginTop: 10,
              marginBottom: 10
            }}
            color='primary'
            onClick={() => {
              setModalOpen(false);
            }}
          >
            キャンセル
          </Button>
          <Button
            variant='contained'
            style={{
              color: '#fff',
              backgroundColor: buttonColor,
              textAlign: 'center',
              marginRight: 10,
              marginTop: 10,
              marginBottom: 10
            }}
            onClick={() => {
              onSaveMarker();
              setModalOpen(false);
              setIsMarkerChecked(true);
            }}
          >
            ここでOK
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default MapMarkerModal;
